import { render, staticRenderFns } from "./IpsCountdown.vue?vue&type=template&id=6e93a528&scoped=true"
import script from "./IpsCountdown.vue?vue&type=script&lang=js"
export * from "./IpsCountdown.vue?vue&type=script&lang=js"
import style0 from "./IpsCountdown.vue?vue&type=style&index=0&id=6e93a528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93a528",
  null
  
)

export default component.exports